import {
  type TTemplateDictionary,
  type TTemplateDictionaryApi,
  type TTemplateDictionaryDto,
  type TTemplateDictionaryForm
} from '@/components/AdminPanel/Directory/types/templates.types';
import { convertActiveStatus } from '@/components/AdminPanel/Shared/helpers/convertActiveStatus';

export const templatesDirectoryMapperFromApi = (
  brand: TTemplateDictionaryApi
): TTemplateDictionary => {
  return {
    config: brand.config,
    isActive: convertActiveStatus.toStr(brand.is_active),
    module: brand.module,
    supportCategory: brand.support_category,
    template: brand.template,
    uuid: brand.uuid
  };
};

export const templatesDirectoryMapperToForm = (
  brand: TTemplateDictionary
): TTemplateDictionaryForm => {
  return {
    config: brand.config,
    isActive: brand.isActive,
    moduleUuid: brand.module.uuid,
    supportCategoryUuid: brand.supportCategory.uuid,
    template: brand.template,
    uuid: brand.uuid
  };
};

export const templatesDirectoryMapperToDto = (
  brand: TTemplateDictionaryForm
): TTemplateDictionaryDto => {
  return {
    config: brand.config,
    is_active: convertActiveStatus.toBoolean(brand.isActive),
    module_uuid: brand.moduleUuid,
    support_category_uuid: brand.supportCategoryUuid,
    template: brand.template,
    uuid: brand.uuid
  };
};
